import React from "react";
import { Link } from "react-router-dom";
import Loader from "../../../icons/Loader";
//Drop down menu for user options
const OverLay = ({ visible, close, text }) => {
  return (
    <div
      className={visible ? "full-screen-modal" : "d-none"}
      onClick={() => close?.()}
    >
      <div className="modal-body-text">{text || "Please wait..."}</div>
      <Loader />
    </div>
  );
};

export default OverLay;
